import httpService from '@/modules/common/services/httpService';

const basePath = '/v3/reviews/business_reviews_settings';
const getReviewSettings = async (businessUid) => httpService.get(`${basePath}/${businessUid}`).then((res) => res.data?.data);
const createReviewSettings = async (settings) => httpService.post(basePath, settings).then((res) => res.data?.data);
const updateReviewSettings = async (businessUid, settings) => httpService.put(`${basePath}/${businessUid}`, settings).then((res) => res.data?.data);

export default {
  getReviewSettings,
  createReviewSettings,
  updateReviewSettings,
};
